import {
  type GetUserGeolocationQuery,
  getCookieUserLocation,
} from "@frontend/roz-sdk-core";

type BackGeoType = GetUserGeolocationQuery["userGeoLocationLog"];

export const calcGeoPlaceInfo = (
  backGeolocation: BackGeoType
): {
  showingPlace: string;
  placeWord: string;
} => {
  const cookieLocation = getCookieUserLocation();

  let showingPlace = "";
  let placeWord = "город";

  if (cookieLocation?.city) {
    showingPlace = cookieLocation.city;
    placeWord = "город";
  } else if (cookieLocation?.region) {
    showingPlace = cookieLocation.region;
    placeWord = "регион";
  } else if (backGeolocation?.city) {
    showingPlace = backGeolocation.city;
    placeWord = "город";
  } else if (backGeolocation?.region) {
    showingPlace = backGeolocation.region;
    placeWord = "регион";
  }

  return { showingPlace, placeWord };
};
